/*
 * BuildDocs пользовательский интерфейс version 0.1.0
 *
 * Copyright © 2021 ООО АДАПТ info@acfs.spb.ru
 *
 * You may use, distribute and modify this code under the
 * terms of the ООО АДАПТ license
 */

import { lazy, Suspense, useEffect } from 'react'

import { routes, useToken } from '@builddocs/data-management'
import { Helmet } from 'react-helmet'
import { Route, Routes, useLocation } from 'react-router-dom'
import { YMInitializer } from 'react-yandex-metrika'

import LoadingSpinner from './components/LoadingSpinner'
import PrivateRoute from './components/privateRoute'
import { title } from './constants/general'

const RefreshPage = lazy(() => import('./screens/token/RefreshPage'))

const SecretRegistrationScreen = lazy(
  () => import('./screens/auth/Registration/SecretRegistrationScreen'),
)

const RegistrationScreen = lazy(
  () => import('./screens/auth/Registration/RegistrationScreen'),
)
const LoginScreen = lazy(() => import('./screens/auth/Login/LoginScreen'))
const LoginIntegration = lazy(
  () => import('./screens/auth/LoginIntegration/TestLoginIntegration'),
)
const ForgotPasswordScreen = lazy(
  () => import('./screens/auth/ForgotPassword/ForgotPasswordScreen'),
)
const RecoverPasswordScreen = lazy(
  () => import('./screens/auth/RecoverPassword/RecoverPasswordScreen'),
)

const HomeScreen = lazy(() => import('./screens/HomeScreen'))

const RootScreen = () => {
  const location = useLocation()
  const state = location.state as { backgroundLocation?: Location }

  const { check } = useToken({
    redirectUrl: location.pathname + location.search,
  })

  useEffect(() => {
    check()
  }, [])

  return (
    <>
      <YMInitializer accounts={[97974770]} />
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <Suspense fallback={<LoadingSpinner isLogo={false} />}>
        <Routes location={state?.backgroundLocation || location}>
          <Route
            element={<RefreshPage />}
            path={`${routes.refresh.base()}/*`}
          />
          <Route
            element={<SecretRegistrationScreen />}
            path={routes.auth.secretSignUp()}
          />
          <Route
            element={<RegistrationScreen />}
            path={routes.auth.signUp() + '/*'}
          />
          <Route element={<LoginScreen />} path={routes.auth.signIn()} />
          <Route
            element={<LoginIntegration />}
            path={routes.auth.signInIntegration()}
          />
          <Route
            element={<ForgotPasswordScreen />}
            path={routes.auth.forgotPassword()}
          />
          <Route
            element={<RecoverPasswordScreen />}
            path={routes.auth.recoverPassword()}
          />
          <Route element={<PrivateRoute component={HomeScreen} />} path="*" />
        </Routes>
      </Suspense>
      {/*<AllertComponent />*/}
    </>
  )
}

export default RootScreen
